export const BASE_SANITY_GRAPHQL_URL = `https://${process.env.REACT_APP_SANITY_PROJECT_ID}.api.sanity.io/v2023-08-01/graphql/production/default`;
